import React from 'react';

export const HeroPhoneShowcase: React.FC = () => {
  return (
    <div className="w-full max-w-[420px] sm:max-w-[480px] lg:max-w-[500px] xl:max-w-[540px] flex items-center justify-center">
      <img
        src="/hero-showcase.webp"
        srcSet="/hero-showcase-mobile.webp 540w, /hero-showcase.webp 849w"
        sizes="(max-width: 640px) 92vw, (max-width: 1024px) 460px, 540px"
        width={849}
        height={1024}
        alt="Zeyilo — Assistant WhatsApp IA : Réponses automatiques, Prise de commandes, Prise de rendez-vous, Service client, Relances intelligentes"
        className="w-full h-auto object-contain select-none pointer-events-none drop-shadow-sm"
        loading="eager"
        fetchPriority="high"
        decoding="async"
        draggable={false}
      />
    </div>
  );
};
